import React from "react";
import { DateTimePicker } from "@material-ui/pickers";
import Picker from "./Picker";

export const DateTimeInput = (props) => (
  <Picker Component={DateTimePicker} {...props} />
);
